<template>
  <v-container fluid>
    <v-navigation-drawer v-model="drawer" app>
      <v-img width="150px" height="150px" class="rounded-circle mx-auto my-8 my-lg-4"
        :src="user.avatar !== null ? `https://api.mylegis.com.br/assets/${user.avatar}` : require('../assets/icon-person.svg')" />

      <h3 style="color:#F15A24" class="px-4 text-center">
        {{ user.first_name }} 
      </h3>

      <!-- <v-divider></v-divider> -->

      <v-list nav>

        <v-list-item v-for="item in itemsMenu" :key="item.title" :to="{ name: item.route }">
          <v-list-item-action class="mr-3">
            <v-icon color="#F15A24">{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="logout()">
          <v-list-item-content>
            Sair
          </v-list-item-content>
          <v-list-item-action>
            <v-icon color="#F15A24">mdi-logout</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main>
      <v-container fluid>
        <v-row class="px-0" :class="intBreakPoint >= 2 ? `py-5 `: ``">
            <v-col class="mt-0 pt-0 d-flex justify-space-between" v-if="intBreakPoint >= 2" cols="12" lg="9">
              <div class="gt-tag" :style="{backgroundColor: label.color}">
                <h4 class="d-flex align-center justify-center"><v-icon class="mr-2" color="white">{{label.icon}}</v-icon> {{label.title}}</h4>
              </div>
              <v-carousel height="60" v-model="showBannerDestaque"  class="px-5" cycle :interval="10000" hide-delimiters :show-arrows="false">
                <small style="font-size:10px !important;">Patrocínio</small>
                <v-carousel-item v-for="b in banners" :key="b.directus_files_id">
                  <a :href="b.link" target="_blank">
                  <v-img :src="`https://api.mylegis.com.br/assets/${b.directus_files_id}`" class="mx-auto mb-10" width="650" contain height="45" />
                  </a>
                </v-carousel-item>
            </v-carousel> 
         
            </v-col>
            <v-col class="d-flex justify-start align-center"  v-if="intBreakPoint <= 2">
              <v-app-bar-nav-icon class="justify-start"
                @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
            </v-col>
            <v-col class="justify-end align-center d-flex">
              <DialogFaq></DialogFaq>
              <v-img contain max-width="100px" max-height="50px" src="../assets/logo.png" />
            </v-col>
            <v-col class="mt-0 pt-0  justify-center d-flex" v-if="intBreakPoint < 2" cols="12" lg="6">
              <div class="gt-tag" :style="{backgroundColor: label.color}">
                  <h4><v-icon color="white">{{label.icon}}</v-icon> {{label.title}}</h4>
              </div>
            </v-col>
          </v-row>
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-container>
</template>
<style scoped>
.v-list-item {
  border-bottom: 2px solid #d8dad8;
  border-radius: 0 !important;
  max-width: 80%;
  margin: auto;
}

.btn {
  font-weight: bold;
}

.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before {
  opacity: 0;
}
</style>
<script>
import DialogFaq  from '../components/DialogFaq.vue'
export default {
  name: "home",
  components: { DialogFaq },
  data() {
    return {
      showFaq: false,
      drawer: true,
      qtdeNotifications: 0,
      items: [
        { title: "Feed", route: "feed", icon: "mdi-rss", color:"#a4a4a4" },
        { title: "Vade-mécuns", route: "legislacoes", icon: "mdi-scale-balance", color:"#F15A24"
        },
        { title: "Minhas Anotações", route: "anotacoes", icon: "mdi-pencil", color:"#a4a4a4" },
        // { title: "Favoritos", route: "favoritos", icon: "mdi-star" },
        { title: "Grupos", route: "grupos", icon: "mdi-account-group", color:"#a4a4a4" },
        // { title: "Amigos", route: "amigos", icon: "mdi-account" },
        { title: "Documentos", route: "documentos", icon: "mdi-file", color:"#a4a4a4" },
        { title: "Perfil", route: "perfil", icon: "mdi-account-circle", color:"#F15A24" },
        { title: "Lei", route: "lei", icon:"mdi-scale-balance", color:"F15A24", hide:true},
        { title: "Grupo", route: "gruposDetalhe", icon:"mdi-account-group", color:"#F15A24", hide:true},
        { title: "Crawler", route: "crawler", icon:"mdi-account-group", color:"#a4a4a4", hide:true  },
        { title: "perfilUsuario", route: "perfilUsuario", icon:"mdi-account-group", color:"#a4a4a4", hide:true  } 
        // { title: "Teste Word", route: "ckeditor", icon: "mdi-file-word" },
      ],
      banners: [],
      showBannerDestaque: 0
    };
  },
  computed: {
    label() { 
      let rout = this.items.filter((e) => e.route === this.$route.name)
      // window.console.log(rout[0])
      return rout[0]
    },
    isHome() {
      return this.$route.name == "feed";
    },
    isPerfil() {
      return this.$route.name == "perfil";
    },
    user() {
      return this.$store.state.user != undefined
        ? this.$store.state.user
        : { first_name: "Meu Perfil" };
    },
    intBreakPoint() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 0;
        case "sm":
          return 1;
        case "md":
          return 2;
        case "lg":
          return 3;
        case "xl":
          return 4;
        default:
          return 0;
      }
    },
    itemsMenu() { 
      return this.items.filter((e) => !e.hide)
    }
  },
  mounted() {
    this.$store.dispatch("getInfo")

    // this.$store.dispatch("getUsuarios");
    this.reloadBanners()
  },
  methods: {
    async reloadBanners() { 
      const { data } = await this.$http.get(
        `/items/banners/?fields=*,banners.*&filter[local][_eq]=painel`
      ) 
      this.banners = data.data[0] ? data.data[0].banners : []
    },
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/");
      });
    },
    openPerfil() {
      this.$router.push("/home/perfil");
    },
  },
};
</script>
